'use client'

import React, { useState } from 'react'

import { useQuery } from '@apollo/client'

import { JoinUsNowModal } from 'Components/Blocks/Modals'
import {
  AboutUsHeroSection,
  FAQSection,
  TeamMembersSection,
  WhyChooseEmajinGolfSection,
} from 'Components/Sections'
import { Column, Loader } from 'Components/UI'
import { APOLLO_CLIENT_CONTEXT_ID } from 'Config/apolloClient'

import { AboutUsPageDocument } from 'GraphQL/DatoCMS/TypedDocuments'

function AboutUsPage() {
  const [joinUsModalModalOpened, setJoinUsModalModalOpened] = useState(false)

  const { data, loading } = useQuery(AboutUsPageDocument, {
    context: { [APOLLO_CLIENT_CONTEXT_ID.Dato]: true },
  })

  if (loading) return <Loader fullScreen size={32} />

  return (
    <Column alignCenter fullWidth>
      <AboutUsHeroSection />

      <WhyChooseEmajinGolfSection
        onAction={() => setJoinUsModalModalOpened(true)}
      />

      <TeamMembersSection
        data={data}
        onAction={() => setJoinUsModalModalOpened(true)}
      />

      <FAQSection data={data?.aboutUsPage?.faq} />

      <JoinUsNowModal
        isOpened={joinUsModalModalOpened}
        onClose={() => setJoinUsModalModalOpened(false)}
      />
    </Column>
  )
}

export default AboutUsPage
